import dayjs from "dayjs";

import Table from "react-bootstrap/Table";

import { MedicalAttendancePaginated } from "@/services/sintegrada/attendanceReport/getMedicalAttendances";
import { TableSkeletons } from "@/components/TableSkeletons";

type Props = {
	isLoading?: boolean;
	medicalAttendancePaginated: MedicalAttendancePaginated;
};

export function MedicalAttendanceTable({ isLoading, medicalAttendancePaginated }: Props) {
	return (
		<Table>
			<thead>
				<tr className="fw-bold">
					<th>Dt. Atendimento</th>
					<th>Nome do paciente</th>
					<th>Dt. Nasc.</th>
					<th>Sexo</th>
					<th>Classificação</th>
					<th>Profissional</th>
					<th>1º Atend.</th>
					<th>Reavaliação</th>
				</tr>
			</thead>

			<tbody>
				{isLoading ? (
					<TableSkeletons numberOfCells={8} numberOfRows={10} />
				) : Boolean(medicalAttendancePaginated?.data?.length) ? (
					medicalAttendancePaginated.data.map((medicalAttendance, index) => {
						const attendanceDate = dayjs(medicalAttendance.attendanceDate).format(
							"DD/MM/YYYY HH:mm"
						);

						const firstAttendanceDate = dayjs(medicalAttendance.firstAttendance).format(
							"DD/MM/YYYY HH:mm"
						);

						const lastEvaluationDate = medicalAttendance.lastEvaluation
							? dayjs(medicalAttendance.lastEvaluation).format("DD/MM/YYYY HH:mm")
							: "N/A";

						const patientBirthdate = dayjs(medicalAttendance.patient.birthdate).format(
							"DD/MM/YYYY"
						);

						return (
							<tr key={`medical-attendance-${index}`}>
								<td>{attendanceDate}</td>
								<td className="text-uppercase">{medicalAttendance.patient.name}</td>
								<td>{patientBirthdate}</td>
								<td>{medicalAttendance.patient.gender}</td>
								<td>{medicalAttendance.riskClassification?.name}</td>
								<td>{medicalAttendance.professional.name}</td>
								<td>{firstAttendanceDate}</td>
								<td>{lastEvaluationDate}</td>
							</tr>
						);
					})
				) : (
					<tr>
						<td colSpan={12} className="text-center text-black-50 fw-bold">
							Nenhum resultado encontrado
						</td>
					</tr>
				)}
			</tbody>
		</Table>
	);
}
